import { render } from "./TrashRedIcon.vue?vue&type=template&id=78d00c28"
import script from "./TrashRedIcon.vue?vue&type=script&lang=js"
export * from "./TrashRedIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__